// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__krRJX","label":"Completed_label__nHmX1"};